import React from 'react';
import { motion } from 'framer-motion';

const EmptyCartMessage = () => {
  return (
    React.createElement(
      motion.div,
      {
        className: "alert alert-info text-center",
        initial: { opacity: 0 },
        animate: { opacity: 1 }
      },
      "Your cart is empty."
    )
  );
};

export default EmptyCartMessage;